import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {MatDialog} from '@angular/material/dialog';
import {RentaComponent} from '@components/popup/renta/renta.component';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-simulator',
    templateUrl: './simulator.component.html',
    styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);

    constructor(
        public authenticationService: AuthenticationService,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;
    }

    optimizeEfficiency() {
        const dialogRef = this.dialog.open(RentaComponent, {
            width: '1000px',
            data: {favorite: this.favorite},
        });

        dialogRef.afterClosed().subscribe(result => {
            this.favorite = Object.assign(this.favorite, result.favorite);
            this.favoriteChange.emit();
        });
    }
}
